import React from 'react'

export default () => (
  <svg>
    <line x1='0' y1='0' x2='100%' y2='100%' />
  </svg>
)
